import { render, staticRenderFns } from "./RbSelectNew.vue?vue&type=template&id=bf6e8754"
import script from "./RbSelectNew.vue?vue&type=script&lang=js"
export * from "./RbSelectNew.vue?vue&type=script&lang=js"
import style0 from "./RbSelectNew.vue?vue&type=style&index=0&id=bf6e8754&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports